export default (function (props, apollo) {
  var query = props.query,
      mutation = props.mutation;
  var useQuery = apollo.useQuery,
      useMutation = apollo.useMutation;

  var _useQuery = useQuery(query),
      loading = _useQuery.loading,
      _useQuery$data = _useQuery.data;

  _useQuery$data = _useQuery$data === undefined ? {} : _useQuery$data;
  var migrationData = _useQuery$data.meEmailMigrationData;

  var meEmailMigrationData = migrationData || {};
  var id = meEmailMigrationData.id,
      doNotShowAgain = meEmailMigrationData.doNotShowAgain;

  var _useMutation = useMutation(mutation),
      emailMigrationMutation = _useMutation[0];

  var onToggleDoNotShowAgain = function onToggleDoNotShowAgain() {
    emailMigrationMutation({ variables: { id: id, input: { doNotShowAgain: !doNotShowAgain } } });
  };

  return {
    loading: loading,
    meEmailMigrationData: meEmailMigrationData,
    onToggleDoNotShowAgain: onToggleDoNotShowAgain
  };
});